import { Injectable, Injector } from '@angular/core';
import { AbstractControlOptions, UntypedFormArray } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { UserDao } from '@app/dao/user/user.dao';
import { PrincipalResidence } from '@app/forms/subscription/definition/interface/subscription';
import FormGroupArray from '../../services/FormGroupArray';
import { take } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  userId: any;
  constructor(
    protected formConstructor: PrFormConstructor,
    protected injector: Injector,
  ) {
    super(formConstructor);

    injector
      .get(UserDao)
      .getAuthentified()
      .pipe(take(1))
      .subscribe(user => {
        this.userId = user.id;
      });
  }

  generateForm(entity: PrincipalResidence) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        ownerId: [entity.ownerId],
        // Défaut affiché ET enregistré (cf. PrincipalResidenceFormComponent.onSubmit) :
        // OWNER pour coller au repli du back, SaveOwnerDataCommandConsumer écrivant
        // AddressSituationEnum.OWNER quand le pledge n'a pas de moyen de détention.
        addressSituation: [entity?.addressSituation || 'OWNER'],
      },
      options,
    );
  }
  generate(entity: PrincipalResidence[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      ownerId: this.userId,
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  extract() {
    return this.form.value.owners;
  }
}
